<template>
  <div class="feedback">
    <Head :title="title"></Head>
    <div class="feedback_bottm">
      <van-form @submit="onSubmit">
        <div class="theme">
          <div class="title">
            主题
            <img src="@/assets/mylogin/notice.png" alt="" />
          </div>
          <div class="van_form">
            <van-field
              v-model="value"
              placeholder="请输入主题"
              style="
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 500;
                color: #999999;
                opacity: 1;
              "
            ></van-field>
          </div>
        </div>
        <div class="content">
          <div class="title">
            反馈内容
            <img src="@/assets/mylogin/notice.png" alt="" />
          </div>
          <div class="van_forms">
            <van-field
              v-model="message"
              input="message"
              rows="2"
              autosize
              type="textarea"
              maxlength="200"
              placeholder="为了更好的服务，请将您的建议或者遇到的问题 告知我们，我们会认真听取及反馈"
              show-word-limit
            />
          </div>
        </div>
        <div class="pictures">
          <van-uploader
            @oversize="onOversize"
            @delete="deleteClzp"
            :before-read="beforeRead"
            :after-read="clzpAfterRead"
            v-model="fileList"
            :max-count="5"
            :max-size="2 * 1024 * 1024"
          >
            <div
              style="
                width: 85px;
                height: 85px;
                background: #f9f9f9;
                border-radius: 8px 8px 8px 8px;
                opacity: 1;
                border: 1px dashed #999999;
                text-align: center;
                padding-top: 20px;
              "
            >
              <img
                style="
                  width: 28px;
                  height: 26px;
                  font-size: 17px;
                  font-family: PingFangSC-Medium, PingFang SC;
                  font-weight: 500;
                  color: #999999;
                "
                src="@/assets/mylogin/uploading.png"
                alt=""
              />
              <p>上传照片</p>
            </div>
          </van-uploader>
          <div class="text">
            图片（支持JPG、JPEG、PNG格式，图片不超过 2M，最多上传5张）
          </div>
        </div>
        <div class="contact">
          <div class="title">联系方式</div>
          <div class="van_form">
            <van-field
              v-model="values"
              placeholder="请留下联系方式"
              style="
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 500;
                color: #999999;
                opacity: 1;
              "
            ></van-field>
          </div>
        </div>
      </van-form>
    </div>
    <div class="exit">
      <van-button class="bot" type="info" @click="onSubmit"
        >提交反馈</van-button
      >
    </div>
  </div>
</template>

<script>
import Head from "../components/headTabs.vue";
import { Toast } from "vant";
export default {
  name: "feedback",
  data() {
    return {
      title: "建议与反馈",
      // 主题
      value: "",
      // 反馈内容
      message: "",
      // 手机号码
      values: "",
      // 上传的文件列表
      fileList: [],
      file: {},
    };
  },
  components: {
    Head,
  },
  methods: {
    to() {
      window.history.go(-1);
    },
    //校验上传图片大小
    onOversize(file) {
      console.log(file);
      Toast("文件大小不能超过2MB");
    },
    //校验图片的格式
    beforeRead(file) {
      if (!/(jpg|jpeg|png|JPG|PNG)/i.test(file.type)) {
        Toast("请上传正确格式的图片");
        return false;
      }
      return true;
    },
    //照片上传事件方法
    clzpAfterRead(file) {
      // 创建一个空对象实例
      let formData = new FormData();
      // 调用append()方法添加数据
      formData.append("file", file.file);
    },
    //照片删除事件方法
    deleteClzp(index) {
      this.fileList.splice(index, 0);
    },
    async onSubmit() {
      if (this.value === "") {
        Toast("请填写标题");
        return;
      } else if (this.value.length > 50) {
        Toast("标题字数过多");
        return;
      } else if (this.message === "") {
        Toast("请描述具体内容");
        return;
      }
      let obj = {
        title: this.value,
        content: this.message,
        attachmentList: this.fileList,
      };
      const resp = await this.$apis.userServe.subFeedback(obj);
      if (resp.resultCode === "200") {
        Toast("提交成功");
        this.value = "";
        this.values = "";
        this.message = "";
        this.fileList = [];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.feedback {
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;
  background: #f5f5f5;
  .feedback_top {
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    line-height: 44px;
    .my {
      width: 150px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      background: #fff;
      text-align: center;
    }
  }
  .feedback_bottm {
    width: 94%;
    background: #fff;
    margin: 12px auto;
    border-radius: 8px 8px 8px 8px;
    overflow: hidden;
    .theme {
      background: #fff;
      margin-top: 25px;
      border-bottom: 1px solid #f5f5f5;
      .title {
        margin-left: 23px;
        font-size: 16px;
        font-family: PingFangSC-Heavy, PingFang SC;
        font-weight: 800;
        color: #333333;
        img {
          width: 9px;
          height: 8px;
          margin-bottom: 7px;
        }
      }
      .van_form {
        padding: 0px 0px 0px 0px;
        .van-field__control {
          padding: 0px 0px 5px 0px;
        }
      }
    }
    .content {
      background: #fff;
      margin-top: 25px;
      .title {
        margin-left: 23px;
        font-size: 16px;
        font-family: PingFangSC-Heavy, PingFang SC;
        font-weight: 800;
        color: #333333;
        img {
          width: 9px;
          height: 8px;
          margin-bottom: 7px;
        }
      }
      .van_forms {
        position: relative;
        .van-cell__value--alone {
          height: 157px;
          font-size: 12px;
          background: #f9f9f9;
          padding: 22px 41px 0px 22px;
          .van-field__body {
            .van-field__control {
              height: 96px !important;
            }
          }
        }
        .van-field__word-limit {
          position: absolute;
          width: 100px !important;
          right: 12px;
          bottom: 11px;
          margin-top: 10px;
          width: 39.5px;
          height: 13.5px;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #999999;
        }
      }
    }
    .pictures {
      background: #fff;
      margin-top: 25px;
      margin-left: 17px;
      overflow: hidden;
      .van-uploader__upload {
        width: 102px;
        height: 102px;
      }
      .text {
        margin-top: 10px;
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
      }
    }
    .contact {
      background: #fff;
      margin-top: 25px;
      margin-bottom: 24px;
      border-bottom: 1px solid #f5f5f5;
      .title {
        margin-left: 23px;
        font-size: 16px;
        font-family: PingFangSC-Heavy, PingFang SC;
        font-weight: 800;
        color: #333333;
      }
      .van_forms {
        .van-cell__value--alone {
          background: #f9f9f9;
        }
      }
    }
  }
  .exit {
    width: 100%;
    height: 44px;
    display: flex;
    justify-content: center;
    align-content: center;
    margin-top: 22px;
    margin-bottom: 50px;
    .bot {
      width: 94%;
      height: 44px;
      border-radius: 22px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fff;
      background: #4a79f1;
    }
  }
}
</style>